/**
 * Active day for availabilty
 */
export const ActiveDay = Object.freeze({
  TODAY: 'today',
  TOMORROW: 'tomorrow',
  NEXT_WORKING_DAY: 'nextWorkingDay',
  FUTURE: 'future',
})
